import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import cn from 'classnames';
import { useInView } from 'react-intersection-observer';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import Link from 'components/UI/Link';
import { pushCustomEvent } from 'utils/analytics';

import * as styles from './BentoCard.module.scss';

export default function BentoCard({ cardId, title, description, link, className, setActive }) {
  const currentLocation = useLocation();
  const [inViewRef, inView] = useInView({ threshold: 1 });

  useEffect(() => {
    if (inView && setActive) {
      setActive(cardId);
    }
  }, [inView, cardId, setActive]);

  const handleClickOnCard = () => {
    pushCustomEvent('ndrsn_bento_block', {
      action: 'click_on_card',
      label: link ?? 'no_link',
      page: currentLocation?.href,
    });
  };

  const handleClickOnTitle = () => {
    pushCustomEvent('ndrsn_bento_block', {
      action: 'click_on_card_title',
      label: link ?? 'no_link',
      page: currentLocation?.href,
    });
  };

  const content = (
    <>
      <Title tag="h3" size="h4" className={styles.title} onClick={handleClickOnTitle}>
        {title}
      </Title>
      <Subtitle className={styles.description}>{description}</Subtitle>
    </>
  );

  return (
    <article
      id={cardId}
      className={cn(styles.wrapper, className, 'bentoCard')}
      ref={inViewRef}
      onClick={handleClickOnCard}
    >
      {link ? (
        <Link className={styles.contentWrapper} href={link}>
          {content}
        </Link>
      ) : (
        <div className={styles.contentWrapper}>{content}</div>
      )}
    </article>
  );
}
